import {QuestConfigResponse, Token, QuestsApi, GetQuestConfigsUserRequest } from "@devour/client";
import getConfig from "@/utils/getConfig";
import { useQuery } from "@tanstack/react-query";

/*
 * QuestConfigResponse, not QuestConfig — the endpoint returns the response
 * projection (prerequisites carry `id`, milestones carry the populated `game` /
 * `photoExampleAsset`, plus the sponsorship-overlay fields applied at runtime).
 * The swagger said `QuestConfig`, so the generated client deserialized with the
 * base model and silently stripped every one of those fields on read.
 */
async function fetchQuestConfigsForUser(fullToken: Token, query: GetQuestConfigsUserRequest): Promise<Array<QuestConfigResponse>> {
    return await new QuestsApi(getConfig(fullToken)).getQuestConfigsUser(query);
}

function getQuestConfigsForUserQuery(fullToken: Token, query: GetQuestConfigsUserRequest) {
    return {
        queryKey: [
            "quest-configs-user",
            fullToken?.id ?? "unauthenticated",
            query,
        ],
        queryFn: () => fetchQuestConfigsForUser(fullToken, query),
        placeholderData: (previousData: any) => previousData, // v5 replacement for keepPreviousData
        /*
         * 5 minutes, matching the server-side quest cache posture. The prior
         * 30-DAY staleTime meant quests authored/edited in Admin didn't
         * surface until a hard refresh — hostile to config-driven surfaces
         * like the Play page, where an Admin edit IS the deploy.
         */
        staleTime: 5 * 60000,
        refetchOnWindowFocus: false,
        enabled: Boolean(query.gameId || query.challenges || query.guildId || query.surface),
    } as const;
}

export function useGetQuestConfigsForUser(fullToken: Token, query: GetQuestConfigsUserRequest) {
    return useQuery(getQuestConfigsForUserQuery(fullToken, query));
}